import ReactFlagsSelect from 'react-flags-select';

import styled from 'styled-components';

export const SelectCountryContainer = styled(ReactFlagsSelect)`
  background-color: #fff;
  color: #212121;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  height: 56px;
  letter-spacing: 0.16px;
  line-height: 1.5;

  & > button {
    background-color: #fff;
    height: 56px;
    outline: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: ${props => (props.fullWidth ? '100%' : '114px')};

    &:focus {
      border: 2px solid #fb8c00;
    }

    &:hover {
      border: 1px solid #666666;
    }

    & > span {
      padding: 0px 4px;
      margin: 0px;
    }
  }
`;
